import { getDefaultItemsListTextareaEditorState } from '../../service/ItemsListTextareaEditor/itemsListTextareaEditor';
import {
    ItemsListTextareaEditorsState,
    ItemsListTextareaEditorState
} from '../../typings/itemsListTextareaEditorState';

export const selectItemsListTextareaEditorValue = (
    editors: ItemsListTextareaEditorsState,
    editorId: string
): ItemsListTextareaEditorState => {
    return editors[editorId] || getDefaultItemsListTextareaEditorState();
};
